import { createFeatureSelector, createSelector } from '@ngrx/store';
import { _STATE_GUIDES_FEATURE_KEY, State } from './guides.reducer';

// Lookup the 'StateGuides' feature state managed by NgRx
export const getStateGuidesState = createFeatureSelector<State>(
	_STATE_GUIDES_FEATURE_KEY,
);

export const getStateGuidesLoaded = createSelector(
	getStateGuidesState,
	(state: State) => state.loaded,
);

export const getStateGuidesError = createSelector(
	getStateGuidesState,
	(state: State) => state.error,
);

/*
 * Select all guides
 */
export const getStateGuides = createSelector(
	getStateGuidesState,
	(state: State) => state.guides,
);

/*
 * All guides
 * Filter based on category
 */
export const getStateDegreeGuides = createSelector(
	getStateGuidesState,
	(state: State) => {
		return filterGuides(state, 'Subject Guide');
	},
);
export const getStateCityGuides = createSelector(getStateGuidesState, (state: State) => {
	return filterGuides(state, 'City Guide');
});
export const getStateCareerGuides = createSelector(
	getStateGuidesState,
	(state: State) => {
		return filterGuides(state, 'Career Guide');
	},
);

/*
 * Single Guide
 */
export const getSingleGuide = createSelector(
	getStateGuidesState,
	(state: State) => state.singleGuide,
);

/*
 * Popular guides
 * Based on category: Subject Degree, Student City, Student Career
 */
export const getStatePopularDegreeGuides = createSelector(
	getStateGuidesState,
	(state: State) => state.subjectDegrees,
);
export const getStatePopularCityGuides = createSelector(
	getStateGuidesState,
	(state: State) => state.studentCity,
);
export const getStatePopularCareerGuides = createSelector(
	getStateGuidesState,
	(state: State) => state.studentCareer,
);

export const filterGuides = (state: any, categoryGuide: string) => {
	if (!state.guides) return;
	const guides = Object.values(state.guides).filter((guide: any) => {
		return guide.category === categoryGuide;
	});
	return guides;
};
